module.exports = __webpack_public_path__ + "img/04.f36c03e8.jpg";